import { render, staticRenderFns } from "./DspPartners.vue?vue&type=template&id=7075c7bb&"
import script from "./DspPartners.vue?vue&type=script&lang=js&"
export * from "./DspPartners.vue?vue&type=script&lang=js&"
import style0 from "./DspPartners.vue?vue&type=style&index=0&id=7075c7bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports